import { Link } from 'react-router-dom';

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background-main text-text-primary">
      <div className="mx-auto flex max-w-6xl flex-col gap-16 px-6 py-24 md:flex-row md:items-center">
        <div className="space-y-6">
          <p className="inline-flex rounded-full border border-background-border px-3 py-1 text-xs uppercase tracking-widest text-text-dimmed">
            Real-time Engagement Intelligence
          </p>
          <h1 className="text-4xl font-bold leading-tight tracking-tight text-text-primary md:text-5xl">
            Digital Classroom Insights
          </h1>
          <p className="text-lg text-text-dimmed">
            A privacy-first virtual classroom leveraging WebRTC, TensorFlow.js, and live analytics to keep every student
            connected and engaged.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/signin"
              className="rounded-lg bg-neon-gradient px-6 py-3 text-sm font-semibold text-white transition hover:shadow-glow"
            >
              Sign In with University SSO
            </Link>
            <a
              href="https://github.com/iiSHAQii/ISAM-GAP"
              target="_blank"
              rel="noreferrer"
              className="rounded-lg border border-background-border px-6 py-3 text-sm font-semibold text-text-primary hover:border-brand transition-colors"
            >
              View Architecture
            </a>
          </div>
        </div>
        <div className="rounded-2xl border border-background-border bg-background-surface p-6 shadow-2xl shadow-glow">
          <p className="text-xs uppercase text-text-dimmed">Live metrics snapshot</p>
          <div className="mt-4 grid grid-cols-2 gap-4 text-center">
            {[
              { label: 'Avg engagement', value: '82%' },
              { label: 'Active sessions', value: '1' },
              { label: 'Low attention alerts', value: '3' },
              { label: 'Model latency', value: '38ms' }
            ].map(({ label, value }) => (
              <div key={label} className="rounded-lg border border-background-border bg-background-main/40 p-4">
                <p className="text-2xl font-bold text-text-primary">{value}</p>
                <p className="text-xs text-text-dimmed">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

